import React, { useState, useRef, useEffect } from "react";
import { ref, push, update, get } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { v4 as uuidv4 } from "uuid";
import backButton from "../../assets/images/arw-back.png";
import startConversation from "../../assets/images/start-conversation.png";
import searchIcon from "../../assets/images/grey-seacrh.png";
import uploadIcon from "../../assets/images/upload.png";
import closeIcon from "../../assets/images/delete.png";
import { useLocation, useNavigate } from "react-router";
import { database } from "../../Utils/firebaseConfig";
import { createSafeListener, cleanupListeners } from "../../Utils/firebaseUtils";
import "./Chat.css";
import docIcon from "../../assets/images/document.png";
import pdfIcon from "../../assets/images/pdf.png";
import genericFileIcon from "../../assets/images/document.png";
import AWS from "aws-sdk";
import {
  AWS_ACCESS_KEY_ID,
  AWS_SECRET_KEY_ID,
  AWS_BUCKET_REGION,
} from "../../Utils/constants";

export default function Chat() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [chatId, setChatId] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [textareaHeight, setTextareaHeight] = useState("auto");
  const [searchTerm, setSearchTerm] = useState("");
  const fileInputRef = useRef(null);
  const [currentUserDetails, setCurrentUserDetails] = useState(null);
  const [senderId, setSenderId] = useState(null);
  const [receiverId, setReceiverId] = useState(null);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const messagesContainerRef = useRef(null);
  const [imageModal, setImageModal] = useState({
    open: false,
    url: "",
    fileName: "",
  });
  const listenersRef = useRef([]);

  const businessDetails = location.state?.businessDetail || null;

  // const getBucketName = () => process.env.REACT_APP_AWS_BUCKET
  const getProfileImage = (user) => {
    if (!user) return startConversation;
    const img = user.profile_image || user.avatar || user.image;
    return img === "N/A" || !img ? startConversation : img;
  };

  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.lastMessage.toLowerCase().includes(searchTerm.toLowerCase())
  );

  console.log(filteredUsers, "filteredUsers");

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (selectedUserId && messagesContainerRef.current) {
      const timer = setTimeout(() => {
        messagesContainerRef.current.scrollTop =
          messagesContainerRef.current.scrollHeight;
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [selectedUserId]);

  const fetchUserByUUID = async (userUUID) => {
    try {
      const usersRef = ref(database, "users");
      const snapshot = await get(usersRef);

      if (snapshot.exists()) {
        const usersArray = [];
        snapshot.forEach((child) => {
          usersArray.push(child.val());
        });
        return usersArray.find((user) => user.user_uuid === userUUID) || null;
      }
      return null;
    } catch (error) {
      console.error("Error fetching users:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const userUUID = localStorage.getItem("user_uuid");
      // console.log(userUUID)
      if (userUUID) {
        const userDetails = await fetchUserByUUID(userUUID);
        console.log(userDetails, "userDetails");
        if (userDetails) {
          setCurrentUserDetails(userDetails);
          setSenderId(userDetails.id);
        }
      }
    };
    fetchCurrentUser();
  }, []);

  useEffect(() => {
    setUsers([]);
    setSelectedUserId(null);
    setMessages([]);
    setTotalUnreadCount(0);
    // Optionally clear localStorage if you use it for chat state
    localStorage.removeItem("totalUnreadCount");
  }, [senderId]);

  useEffect(() => {
    const fetchReceiverDetails = async () => {
      if (businessDetails?.user_uuid) {
        const userDetails = await fetchUserByUUID(businessDetails.user_uuid);
        if (userDetails) {
          setReceiverId(userDetails.id);
          setSelectedUserId(userDetails.id);
        }
      }
    };
    fetchReceiverDetails();
  }, [businessDetails?.user_uuid]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setSenderId(currentUserDetails?.id || user.uid);
      } else {
        setSenderId(null);
      }
    });
    return () => unsubscribe();
  }, [currentUserDetails]);

  // Cleanup all listeners when component unmounts
  useEffect(() => {
    return () => {
      try {
        cleanupListeners(listenersRef.current);
        listenersRef.current = [];
      } catch (error) {
        console.warn("Error during final cleanup:", error);
      }
    };
  }, []);

  const generateChatRoomKey = (user1Id, user2Id) => {
    const firstId = user1Id > user2Id ? user1Id : user2Id;
    const secondId = user1Id > user2Id ? user2Id : user1Id;
    return `${firstId}-${secondId}`;
  };

  useEffect(() => {
    if (!senderId) return;
    // console.log(senderId)
    
    const chatListener = createSafeListener(
      database,
      `users/${senderId}/chats`,
      (snapshot) => {
        const data = snapshot.val();
        console.log(data, "data");
        if (data) {
          const userList = Object.entries(data).map(([userId, chatData]) => {
            const lastMsg = chatData.lastMessage || {};
            let lastMessagePreview = "No messages yet";

            if (lastMsg.text) {
              lastMessagePreview = lastMsg.text;
            } else if (lastMsg.image || lastMsg.file || lastMsg.video) {
              if (lastMsg.user?._id === senderId) {
                lastMessagePreview = "You sent an attachment";
              } else {
                lastMessagePreview = "You received an attachment";
              }
            }

            const isBusinessUser =
              businessDetails?.user_uuid && userId === receiverId;

            return {
              id: userId,
              name: isBusinessUser
                ? businessDetails.userDetail?.name
                : chatData.user?.name || "Unknown",
              lastMessage: lastMessagePreview,
              profile_image: isBusinessUser
                ? businessDetails.userDetail?.profile_image
                : chatData.user?.profile_image || startConversation,
              timestamp: chatData.timestamp || new Date().toISOString(),
              unreadCount: chatData.unreadCount || 0,
              lastMessageTime: lastMsg.createdAt || "",
            };
          });

          userList.sort(
            (a, b) =>
              new Date(b.lastMessageTime || b.timestamp) -
              new Date(a.lastMessageTime || a.timestamp)
          );

          if (receiverId && !userList.some((user) => user.id === receiverId)) {
            userList.unshift({
              id: receiverId,
              name: businessDetails?.userDetail?.name || "Business",
              lastMessage: "Start a conversation",
              profile_image:
                businessDetails?.userDetail?.profile_image || startConversation,
              timestamp: new Date().toISOString(),
              unreadCount: 0,
            });
          }

          setUsers(userList);
          const totalUnread = userList.reduce(
            (sum, user) => sum + (user.unreadCount || 0),
            0
          );
          setTotalUnreadCount(totalUnread);
          localStorage.setItem("totalUnreadCount", totalUnread);
          setLoading(false);
        } else if (receiverId) {
          setUsers([
            {
              id: receiverId,
              name: businessDetails?.userDetail?.name || "Business",
              lastMessage: "Start a conversation",
              profile_image:
                businessDetails?.userDetail?.profile_image || startConversation,
              timestamp: new Date().toISOString(),
              unreadCount: 0,
            },
          ]);
          setTotalUnreadCount(0);
        } else {
          setLoading(false);
          setUsers([]);
          setTotalUnreadCount(0);
        }
      },
      (error) => {
        console.error("Error in user chats listener:", error);
      }
    );

    listenersRef.current.push(chatListener);

    return () => {
      try {
        chatListener.cleanup();
        // Remove from listeners array
        const index = listenersRef.current.indexOf(chatListener);
        if (index > -1) {
          listenersRef.current.splice(index, 1);
        }
      } catch (error) {
        console.warn("Error cleaning up user chats listener:", error);
      }
    };
  }, [senderId, businessDetails, receiverId]);

  useEffect(() => {
    if (!senderId || !selectedUserId) return;
    
    const setupChat = async () => {
      try {
        const updates = {};
        updates[`users/${senderId}/chats/${selectedUserId}/unreadCount`] = 0;
        updates[
          `users/${senderId}/chats/${selectedUserId}/lastMessage/unread`
        ] = false;
        updates[
          `users/${selectedUserId}/chats/${senderId}/lastMessage/unread`
        ] = false;
        update(ref(database), updates);

        const newChatId = generateChatRoomKey(senderId, selectedUserId);
        const chatRef = ref(database, `chats/${newChatId}`);
        const chatSnapshot = await get(chatRef);
        setChatId(newChatId);

        if (chatSnapshot.exists() || !chatSnapshot.exists()) {
          setChatId(newChatId);
        }
        // console.log(newChatId,'newChatId')
        
        const messagesListener = createSafeListener(
          database,
          `chats/${newChatId}/messages`,
          (snapshot) => {
            const data = snapshot.val();
            if (data) {
              const messageList = Object.entries(data).map(([key, value]) => ({
                id: key,
                ...value,
                from: value.from === senderId ? "sender" : "receiver", // Use 'from' for alignment
                timestamp: new Date(value.createdAt),
                isImage: !!value.image,
                isFile: !!value.file,
                fileIcon: value.file ? getFileIcon(value.fileType) : null,
              }));
              messageList.sort((a, b) => a.timestamp - b.timestamp);
              setMessages(messageList);
            } else {
              setMessages([]);
            }
          },
          (error) => {
            console.error("Error in messages listener:", error);
          }
        );

        listenersRef.current.push(messagesListener);
        return messagesListener;
      } catch (error) {
        console.error("Error setting up chat:", error);
        return null;
      }
    };

    let messagesListener = null;
    setupChat().then(listener => {
      messagesListener = listener;
    });

    return () => {
      try {
        if (messagesListener) {
          messagesListener.cleanup();
          // Remove from listeners array
          const index = listenersRef.current.indexOf(messagesListener);
          if (index > -1) {
            listenersRef.current.splice(index, 1);
          }
        }
      } catch (error) {
        console.warn("Error cleaning up messages listener:", error);
      }
    };
  }, [senderId, selectedUserId]);

  const adjustTextareaHeight = (element) => {
    element.style.height = "auto";
    element.style.height = `${element.scrollHeight}px`;
    setTextareaHeight(`${element.scrollHeight}px`);
  };

  const handleTextareaChange = (e) => {
    setMessageInput(e.target.value);
    adjustTextareaHeight(e.target);
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);

    const newAttachments = files.map((file) => {
      let type = "file";
      let preview = getFileIcon(file.type);

      if (file.type.startsWith("image/")) {
        if (file.type === "image/gif") {
          type = "gif";
          preview = URL.createObjectURL(file);
        } else {
          type = "image";
          preview = URL.createObjectURL(file);
        }
      } else if (file.type.startsWith("video/")) {
        type = "video";
        preview = URL.createObjectURL(file);
      }

      return {
        id: uuidv4(),
        file,
        preview,
        type,
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
      };
    });

    setAttachments([...attachments, ...newAttachments]);
  };

  const getFileIcon = (fileType) => {
    if (!fileType) return genericFileIcon;
    if (fileType.includes("pdf")) return pdfIcon;
    if (
      fileType.includes("document") ||
      fileType.includes("msword") ||
      fileType.includes("wordprocessing")
    )
      return docIcon;
    return genericFileIcon;
  };

  const removeAttachment = (id) => {
    const attachmentToRemove = attachments.find((att) => att.id === id);
    if (
      attachmentToRemove?.preview &&
      (attachmentToRemove.type === "image" ||
        attachmentToRemove.type === "video" ||
        attachmentToRemove.type === "gif")
    ) {
      URL.revokeObjectURL(attachmentToRemove.preview);
    }
    setAttachments(attachments.filter((att) => att.id !== id));
  };

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY_ID,
    region: process.env.REACT_APP_AWS_BUCKET_REGION,
  });

  const s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    signatureVersion: "v4",
  });

  const uploadToS3 = async (bucketName, filename, file, contentType) => {
    const params = {
      Bucket: bucketName,
      Key: `${contentType}/${filename}`,
      Body: file,
      ContentType: contentType,
    };

    try {
      const data = await s3.upload(params).promise();
      return data.Location;
    } catch (error) {
      console.error("Upload error:", error);
      return "";
    }
  };
  
  const sendMessage = async () => {
    if (
      (!messageInput.trim() && attachments.length === 0) ||
      !chatId ||
      !senderId ||
      !selectedUserId
    )
      return;

    try {
      console.log(currentUserDetails, "currentUserDetails");
      let messageData = {
         _id: uuidv4(),
        createdAt: new Date().toISOString(),
        user: {
          _id: currentUserDetails?.user_uuid,
          name: currentUserDetails?.name,
          avatar:
            currentUserDetails?.profile_image && currentUserDetails?.profile_image !== "N/A"
              ? currentUserDetails.profile_image
              : "N/A",
        },
        from: senderId,
      };

      if (attachments.length > 0) {
        const attachment = attachments[0];
        const bucketName = process.env.REACT_APP_AWS_BUCKET;

        const contentType =
          attachment.type === "image" || attachment.type === "gif"
            ? `image/${attachment.file.type.split("/")[1] || "jpeg"}`
            : attachment.file.type;

        const filename = `${uuidv4()}.${attachment.file.name.split(".").pop()}`;

        const url = await uploadToS3(
          bucketName,
          filename,
          attachment.file,
          contentType
        );

        if (attachment.type === "image" || attachment.type === "gif") {
          messageData = {
            ...messageData,
            image: url,
            format: attachment.file.type.split("/")[1],
          };
        } else if (attachment.type === "video") {
          messageData = {
            ...messageData,
            video: url,
            format: attachment.file.type.split("/")[1],
          };
        } else {
          messageData = {
            ...messageData,
            file: url,
            fileName: attachment.file.name,
            fileType: attachment.file.type,
            fileSize: attachment.file.size,
          };
        }
      } else {
        messageData = {
          ...messageData,
          text: messageInput,
        };
      }

      const messagesRef = ref(database, `chats/${chatId}/messages`);
      await push(messagesRef, messageData);
      const receiverChatRef = ref(
        database,
        `users/${selectedUserId}/chats/${senderId}`
      );
      const receiverChatSnapshot = await get(receiverChatRef);
      const currentUnreadCount = receiverChatSnapshot.exists()
        ? receiverChatSnapshot.val().unreadCount || 0
        : 0;

      const updates = {};
      const receiverUser = users.find((u) => u.id === selectedUserId);

      updates[`users/${senderId}/chats/${selectedUserId}`] = {
        lastMessage: {
          ...messageData,
          unread: false,
        },
        user: {
          _id: selectedUserId,
          name:
            businessDetails?.user_uuid && selectedUserId === receiverId
              ? businessDetails.userDetail?.name
              : receiverUser?.name || "User",
          avatar:
            (businessDetails?.user_uuid && selectedUserId === receiverId
              ? businessDetails.userDetail?.avatar
              : receiverUser?.avatar) || getProfileImage(receiverUser), // fallback to default
        },
        timestamp: new Date().toISOString(),
        unreadCount: 0,
      };

      updates[`users/${selectedUserId}/chats/${senderId}`] = {
        lastMessage: {
          ...messageData,
          unread: true,
        },
        user: {
          _id: senderId,
          name: currentUserDetails?.name || "User",
          avatar: currentUserDetails?.avatar || getProfileImage(currentUserDetails), // fallback to default
        },
        timestamp: new Date().toISOString(),
        unreadCount: currentUnreadCount + 1,
      };

      await update(ref(database), updates);
      setMessageInput("");
      setAttachments([]);
      setTextareaHeight("auto");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const renderAttachmentPreview = () =>
    attachments.map((att) => (
      <div key={att.id} className="attachment-preview">
        {att.type === "image" || att.type === "gif" ? (
          <img src={att.preview} alt="Preview" />
        ) : att.type === "video" ? (
          <video src={att.preview} controls width={120} height={80} />
        ) : (
          <div className="file-preview">
            <img src={att.preview} alt="File icon" className="file-icon" />
            <span className="file-name">{att.fileName}</span>
          </div>
        )}
        <button
          className="remove-attachment"
          onClick={() => removeAttachment(att.id)}
        >
          <img src={closeIcon} alt="Remove" />
        </button>
      </div>
    ));

  const formatFileSize = (bytes) => {
    if (!bytes) return "";
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1) + " " + sizes[i]);
  };

  const renderFileMessage = (msg) => {
    const fileSize = msg.fileSize ? ` (${formatFileSize(msg.fileSize)})` : "";
    const fileName = msg.fileName || "Download file";

    return (
      <div className="file-message-container">
        <a
          href={msg.file}
          target="_blank"
          rel="noopener noreferrer"
          className="file-message-link"
        >
          <div className="file-message-content">
            <img
              src={msg.fileIcon || getFileIcon(msg.fileType)}
              alt="File icon"
              className="file-message-icon"
            />
            <div className="file-message-info">
              <div className="file-message-name">{fileName}</div>
              <div className="file-message-type">
                {msg.fileType?.split("/")[1] || "File"}
                {fileSize}
              </div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  const handleImageClick = (url, fileName) => {
    setImageModal({ open: true, url, fileName });
  };

  const closeImageModal = () => {
    setImageModal({ open: false, url: "", fileName: "" });
  };

  const renderMessage = (msg) => {
    const isBusinessUser =
      msg.from === "receiver" &&
      businessDetails?.user_uuid &&
      selectedUserId === receiverId;

    const user = isBusinessUser
      ? {
          name: businessDetails.userDetail?.name,
          profile_image: businessDetails.userDetail?.profile_image,
        }
      : {
          name:
            msg.from === "sender"
              ? currentUserDetails?.name
              : users.find((u) => u.id === selectedUserId)?.name,
          profile_image:
            msg.from === "sender"
              ? currentUserDetails?.profile_image
              : users.find((u) => u.id === selectedUserId)?.profile_image,
        };

    return (
      <div className={`chat-bubble-wrapper ${msg.from}`} key={msg.id}>
        {msg.from === "receiver" && (
          <img
            src={getProfileImage(user)}
            alt="receiver"
            className="chat-avatar"
          />
        )}

        <div className="message-content">
          {msg.image ? (
            <div className={`message-bubble ${msg.from} image-bubble`}>
              <img
                src={msg.image}
                alt="attachment"
                className="message-image"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleImageClick(msg.image, msg.fileName || "image.jpg")
                }
              />
            </div>
          ) : msg.video ? (
            <div className={`message-bubble ${msg.from} video-bubble`}>
              <video
                src={msg.video}
                controls
                className="message-video"
                width={220}
              />
            </div>
          ) : msg.file ? (
            <div className={`message-bubble ${msg.from} file-bubble`}>
              {renderFileMessage(msg)}
            </div>
          ) : (
            <div className={`message-bubble ${msg.from} text-bubble`}>
              {msg.text}
            </div>
          )}
          <div className="message-time">
            {msg.timestamp.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>

        {msg.from === "sender" && (
          <img
            src={getProfileImage(user)}
            alt="sender"
            className="chat-avatar"
          />
        )}
      </div>
    );
  };

  return (
    <div className="chat-app">
      <div className="header-container">
        <div className="back-button-container" onClick={() => navigate(-1)}>
          <img src={backButton} className="back-arrow" alt="Back" />
          <span className="back-text">Back</span>
        </div>
      </div>

      <div className="content-wrapper">
        <div className="message-container">
          <div className="message-header">
            <div className="title-with-badge">
              <h1 className="message-title">Messages</h1>
              {totalUnreadCount > 0 && (
                <span className="unread-count">{totalUnreadCount}</span>
              )}
            </div>
            <div className="chat-divider"></div>
          </div>
          <div className="search-container">
            <img src={searchIcon} className="search-icon" alt="Search" />
            <input
              type="text"
              className="search-input-box"
              placeholder="Search Messages"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="users-list">
            {loading ? (
              <div className="loading-users">Loading conversations...</div>
            ) : filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <div
                  key={user.id}
                  className={`user-item ${
                    selectedUserId === user.id ? "selected" : ""
                  }`}
                  onClick={() => setSelectedUserId(user.id)}
                >
                  <div className="user-content">
                    <img
                      src={getProfileImage(user)}
                      className="user-avatar"
                      alt={user.name}
                    />
                    <div className="user-details">
                      <div className="user-info">
                        <div className="user-name">{user.name}</div>
                        {user.unreadCount > 0 && (
                          <div className="unread-count">{user.unreadCount}</div>
                        )}
                      </div>
                      <div className="user-last-message">
                        {user.lastMessage.length > 25
                          ? `${user.lastMessage.substring(0, 25)}...`
                          : user.lastMessage}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>

        {selectedUserId ? (
          <div className="chat-container">
            <div className="chat-header">
              <div className="chat-user">
                <img
                  src={
                    businessDetails?.user_uuid && selectedUserId === receiverId
                      ? getProfileImage(businessDetails.userDetail)
                      : getProfileImage(
                          users.find((u) => u.id === selectedUserId)
                        )
                  }
                  alt="user"
                  className="chat-user-avatar"
                />
                <div>
                  <div className="chat-user-name">
                    {businessDetails?.user_uuid && selectedUserId === receiverId
                      ? businessDetails.userDetail?.name
                      : users.find((u) => u.id === selectedUserId)?.name}
                  </div>
                  {/* <div className="chat-user-status">🟢 Online</div> */}
                </div>
              </div>
            </div>

            <div className="chat-messages" ref={messagesContainerRef}>
              {messages.length > 0 ? (
                messages.map((msg) => renderMessage(msg))
              ) : (
                <div className="empty-chat">
                  <img
                    src={startConversation}
                    className="empty-chat-icon"
                    alt="No messages"
                  />
                  <p>
                    Start a new conversation with{" "}
                    {businessDetails?.user_uuid && selectedUserId === receiverId
                      ? businessDetails.userDetail?.name
                      : users.find((u) => u.id === selectedUserId)?.name}
                  </p>
                </div>
              )}
            </div>

            <div className="chat-input-area">
              {attachments.length > 0 && (
                <div className="attachments-preview">
                  {renderAttachmentPreview()}
                </div>
              )}
              <div className="chat-input-wrapper">
                <button
                  className="upload-button"
                  onClick={() => fileInputRef.current.click()}
                >
                  <img src={uploadIcon} className="upload-icon" alt="Upload" />
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    multiple
                    accept="image/*,video/*,.pdf,.doc,.docx,.txt,.xls,.xlsx"
                    style={{ display: "none" }}
                  />
                </button>
                <textarea
                  rows="1"
                  placeholder="Type a message"
                  className="chat-input"
                  value={messageInput}
                  onChange={handleTextareaChange}
                  onKeyPress={handleKeyPress}
                  style={{ height: textareaHeight }}
                />
                <button
                  className="chat-send"
                  onClick={sendMessage}
                  disabled={!messageInput.trim() && attachments.length === 0}
                >
                  ➤
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="empty-container">
            <img
              src={startConversation}
              className="empty-icon"
              alt="No messages"
            />
            <p className="empty-text">
              {users.length === 0
                ? "No conversations yet"
                : "Select a conversation to view messages"}
            </p>
          </div>
        )}
      </div>

      {/* Image Modal Popup */}
      {imageModal.open && (
        <div className="image-modal-overlay" onClick={closeImageModal}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={imageModal.url} alt="Full" className="image-modal-img" />
            <a
              href={imageModal.url}
              download={imageModal.fileName}
              className="image-modal-download"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Image
            </a>
            <button className="image-modal-close" onClick={closeImageModal}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
